import cn from 'classnames';
import { rm } from 'utils';
import { IconMastercard } from 'components/Shared/Icon/themes/PP/iconMastercard';
import { IconVisa } from 'components/Shared/Icon/themes/PP/iconVisa';
import postnord from 'assets/img/polarpumpen/postnord.png';
import svea from 'assets/img/polarpumpen/svea-mini.png';
import tryggehandel from 'assets/img/polarpumpen/tryggehandel.png';
import styles from './safeecom.scss';

interface Props {
  className?: string;
}

export const SafeECom = ({ className }: Props) => (
  <div className={cn(styles.safeECom, className)}>
    <h3 className={styles.title}>{rm('footer_safeecom_heading')}</h3>
    <div className={styles.icons}>
      <IconMastercard size="large" />
      <IconVisa size="large" />
      <img src={svea} />
      <a href="https://www.tryggehandel.se/butik/?id=712">
        <img src={tryggehandel} />
      </a>
      <img src={postnord} />
    </div>
  </div>
);
